module.exports = __webpack_public_path__ + "img/Stock_icon.98fd39ff.png";